function ErroAPIDados() {
    return (
        <div className="w-full mx-auto flex items-center justify-center h-80">
            <img className="" src="https://copycon.com.br/wp-content/uploads/2018/07/o-maior-erro-no-marketing-300x336.png" alt="" />
        </div>
    );
}

export default ErroAPIDados;